import React, { useLayoutEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "justifiedGallery/dist/css/justifiedGallery.min.css";
import App from './App';
import { BrowserRouter, useLocation } from 'react-router-dom'

const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
        document.documentElement.scrollTo({ top: 0, behavior: 'instant' });
    }, [location.pathname]);
    return children
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<BrowserRouter><Wrapper><App /></Wrapper></BrowserRouter>);